import { iconsLookupsHelper } from "@helpers/iconsLookup";
import Accordion from "@components/shared/accordion";
import { GQLCategories } from "@gql/types/gql";
import styles from "./style.module.scss";
const MainContent = ({
    parentCategories,
    allCategories,
}: {
    parentCategories: GQLCategories[];
    allCategories: { [x: number]: GQLCategories[] };
}) => {
    const parentCategoriesHaveChildren = parentCategories.filter(
        (category) =>
            allCategories[category?.id as number] &&
            allCategories[category?.id as number].length > 0,
    );
    return (
        <div>
            {parentCategoriesHaveChildren &&
                parentCategoriesHaveChildren.map((category) => (
                    <div key={category?.id}>
                        <div
                            style={{
                                background: " #0E2450",
                            }}
                            className="lg:ps-8 ps-4 lg:gap-6 gap-4 flex  items-center  mt-10  py-3 lg1048:py-5 rounded-lg "
                        >
                            <div className={`${styles["iconStyle"]}`}>
                                {iconsLookupsHelper(category?.slug as string)}
                            </div>
                            <h2 className="font-bold text-xl lg1048:text-2xl text-white">
                                {category?.label ?? category?.name}
                            </h2>
                        </div>
                        <Accordion
                            items={allCategories[category?.id as number]}
                            type="categories"
                        />
                    </div>
                ))}
        </div>
    );
};
export default MainContent;
